import React from 'react'
import CommonBox from './components/CommonBox'
import Cash1Component from './components/Cash1Component'
import GifImagesSection from './components/GifImagesSection'
import Cash2Component from './components/Cash2Component'

const Cash2 = () => {
  return (
    <>
      <section className='cash2-section'>
        <CommonBox heading=" 환전하기 " englishHeading=" exchange" isEnglishHeadingOnMobile={true} isAuthenticated={true}>
          <Cash2Component />
        </CommonBox>
      </section>
      <section className='gif-section flex lg:hidden items-center justify-center'>
        <GifImagesSection />
      </section>
    </>
  )
}

export default Cash2